import React from "react";
import { storiesOf } from "@storybook/react";
import { withKnobs, text, select } from "@storybook/addon-knobs";
import withReadme from "storybook-readme/with-readme";
import Icon from "./Icon";
import UIIconList from "./ui-icons-list";
import NucleoIconList from "./nuleo-icons-list";
import IconList from "../IconList.json";
import IconREADME from "../README.md";

const stories = storiesOf("Components/Icon", module);

stories.addDecorator(withKnobs);
stories.addDecorator(withReadme(IconREADME));

stories.add("Default", () => (
  <Icon
    path={text("path", "./icons/nucleo/business-finance/small/math.svg")}
    size={select("size", ["xs", "s", "m", "l", "xl"], "s")}
  />
));

stories.add("SvgIcons", () => {
  const getSocialIcon = (name, props) => {
    switch (name) {
      case "facebook":
        return (
          <path
            {...props}
            d="M18.55 30V17.4h3.825L23 11.8h-4.45V9.073c0-1.442.037-2.873 2.052-2.873h2.04V2.196c0-.06-1.753-.196-3.526-.196-3.704 0-6.023 2.32-6.023 6.58v3.22H9v5.6h4.093V30h5.457z"
          />
        );
      default:
        return <path />;
    }
  };

  return (
    <React.Fragment>
      <Icon.SVGIcon name="success" size="xl" />
      <Icon.SVGIcon
        name="facebook"
        size="l"
        fill="#246b3f"
        getExternalIconPath={getSocialIcon}
      />
      <Icon.SVGIcon
        size="m"
        icon={
          <path
            fill="#00129a"
            d="M16,2 C19.8024,2 20.2798,2.0168 21.7722,2.084 C23.2618,2.1526 24.2796,2.3892 25.1714,2.735 C26.0912,3.0934 26.8724,3.5722 27.6494,4.3492 C28.4292,5.1276 28.908,5.9088 29.265,6.83 C29.6122,7.7204 29.8488,8.7368 29.9146,10.2278 C29.9832,11.7216 30,12.1976 30,16 C30,19.8024 29.9832,20.2798 29.9146,21.7722 C29.8488,23.2632 29.6122,24.2796 29.265,25.1714 C28.908,26.0912 28.4292,26.8724 27.6494,27.6494 C26.8724,28.4292 26.0912,28.908 25.1714,29.265 C24.2796,29.6122 23.2618,29.8488 21.7722,29.9146 C20.2798,29.9832 19.8024,30 16,30 C12.1976,30 11.7216,29.9832 10.2278,29.9146 C8.7382,29.8488 7.7204,29.6122 6.83,29.265 C5.9088,28.908 5.1276,28.4292 4.3492,27.6494 C3.5722,26.8724 3.0934,26.0912 2.735,25.1714 C2.3892,24.2796 2.1526,23.2632 2.084,21.7722 C2.0168,20.2798 2,19.8024 2,16 C2,12.1976 2.0168,11.7216 2.084,10.2278 C2.1526,8.7368 2.3892,7.7204 2.735,6.83 C3.0934,5.9088 3.5722,5.1276 4.3492,4.3492 C5.1276,3.5722 5.9088,3.0934 6.83,2.735 C7.7204,2.3892 8.7382,2.1526 10.2278,2.084 C11.7216,2.0168 12.1976,2 16,2 Z M16,5 C12.4174189,5 11.993413,5.01341791 10.5778239,5.07782386 C9.26957795,5.13820444 8.55977068,5.35557453 8.08611857,5.54074164 C7.46084411,5.78360576 7.01268602,6.07477434 6.54440107,6.54440107 C6.07477434,7.01268602 5.78360576,7.46084411 5.54074164,8.08611857 C5.35557453,8.55977068 5.13820444,9.26957795 5.07782386,10.5778239 C5.01341791,11.993413 5,12.4174189 5,16 C5,19.5825811 5.01341791,20.006587 5.07782386,21.4221761 C5.13820444,22.7304221 5.35557453,23.4402293 5.54074164,23.9125396 C5.78360576,24.5391559 6.07477434,24.9859722 6.54440107,25.4569407 C7.01268602,25.9252257 7.46084411,26.2163942 8.08611857,26.4606001 C8.55977068,26.6444255 9.26957795,26.8631374 10.5778239,26.9221761 C11.993413,26.9865821 12.4174189,27 16,27 C19.5825811,27 20.006587,26.9865821 21.4221761,26.9221761 C22.7304221,26.8631374 23.4402293,26.6444255 23.9125396,26.4606001 C24.5391559,26.2163942 24.9859722,25.9252257 25.4569407,25.4569407 C25.9252257,24.9859722 26.2163942,24.5391559 26.4606001,23.9125396 C26.6444255,23.4402293 26.8631374,22.7304221 26.9221761,21.4221761 C26.9865821,20.006587 27,19.5825811 27,16 C27,12.4174189 26.9865821,11.993413 26.9221761,10.5778239 C26.8631374,9.26957795 26.6444255,8.55977068 26.4606001,8.08611857 C26.2163942,7.46084411 25.9252257,7.01268602 25.4569407,6.54440107 C24.9859722,6.07477434 24.5391559,5.78360576 23.9125396,5.54074164 C23.4402293,5.35557453 22.7304221,5.13820444 21.4221761,5.07782386 C20.006587,5.01341791 19.5825811,5 16,5 Z M16,9 C19.8660175,9 23,12.1339825 23,16 C23,19.8660175 19.8660175,23 16,23 C12.1339825,23 9,19.8660175 9,16 C9,12.1339825 12.1339825,9 16,9 Z M16,20 C18.2094209,20 20,18.2096895 20,16.0006 C20,13.7915104 18.2094209,12 16,12 C13.7905791,12 12,13.7915104 12,16.0006 C12,18.2096895 13.7905791,20 16,20 Z M25,8.5 C25,9.32875 24.32875,10 23.5,10 C22.67125,10 22,9.32875 22,8.5 C22,7.67125 22.67125,7 23.5,7 C24.32875,7 25,7.67125 25,8.5 Z"
          />
        }
      />
    </React.Fragment>
  );
});

stories.add("UI Icon", () => {
  const filterIcon = iconList => iconList.name === "ui";
  const uiIconFolder = IconList.children.find(filterIcon);

  return <UIIconList iconList={uiIconFolder} />;
});
stories.add("Social Icon", () => {
  const filterIcon = iconList => iconList.name === "social";
  const socialIconFolder = IconList.children.find(filterIcon);

  return <UIIconList iconList={socialIconFolder} />;
});
stories.add("Logo Icon", () => {
  const filterIcon = iconList => iconList.name === "logos";
  const logoIconFolder = IconList.children.find(filterIcon);

  return <UIIconList iconList={logoIconFolder} />;
});

stories.add("Doctype Icon", () => {
  const filterIcon = iconList => iconList.name === "doctype";
  const doctypeIconFolder = IconList.children.find(filterIcon);

  return <UIIconList iconList={doctypeIconFolder} />;
});

stories.add("Nucleo Icon small", () => (
  <NucleoIconList size={"small"} iconList={IconList} />
));
stories.add("Nucleo Icon large", () => (
  <NucleoIconList size={"large"} iconList={IconList} />
));
